import path from 'path'
import _ from 'lodash'
import { useState } from 'react'
import { SubscriptionClient } from 'subscriptions-transport-ws'
import { execute } from 'apollo-link'
import { WebSocketLink } from 'apollo-link-ws'
import gql from 'graphql-tag'
import configment from '@adc/configment'
import logger from '@adc/logger'
import { useMountEffect } from './lifecycle'

export const useActivityMonitor = activityReference => {
  const [currentWatchers, setWatchers] = useState([])

  useMountEffect(() => {
    const client = new SubscriptionClient(
      path.join(
        configment.get('RESI_GRAPH_API_WS_URL_EXTERNAL'),
        '/graphql/subscriptions'
      ),
      { reconnectionAttempts: 3 }
    )

    const link = new WebSocketLink(client)

    execute(link, {
      query: gql`
        subscription toolkitBtb_monitorActivity {
          monitorActivity(activityReference: "${activityReference}") {
            watchers {
              id
              first_name
              last_name
              connected_at
            }
          }
        }
      `,
    }).subscribe(
      event => {
        const activity = _.get(event, 'data.monitorActivity', {})

        if (_.isEmpty(activity)) return

        setWatchers(activity.watchers)
      },
      error => logger.error(error)
    )

    return () => client.close()
  })

  return currentWatchers
}
